module.exports = __webpack_public_path__ + "static/media/logoEyeFlowNameless32.38d20a42.png";